const addressDataInit = {
  zip: '',
  city: '',
  street: '',
  streetType: '',
  house: ''
};

const orderDataInit = {
  name: '',
  email: '',
  phone: '+36',
  date: '',
  time: '',
  location: '',
  payMethod: '',
  description: ''
};

const modalDataInit = {
  open: false,
  callBack: null,
  title: '',
  content: '',
  closable: true
};

const days = [
  { id: '0', name: 'Vasárnap' },
  { id: '1', name: 'Hétfő' },
  { id: '2', name: 'Kedd' },
  { id: '3', name: 'Szerda' },
  { id: '4', name: 'Csütörtök' },
  { id: '5', name: 'Péntek' },
  { id: '6', name: 'Szombat' }
];

const streetTypes = [
  { id: 'út', name: 'út' },
  { id: 'utca', name: 'utca' },
  { id: 'körút', name: 'körút' },
  { id: 'tér', name: 'tér' },
  { id: 'dűlő', name: 'dűlő' },
  { id: 'kert', name: 'kert' },
  { id: 'ltp', name: 'ltp' },
  { id: 'park', name: 'park' },
  { id: 'sor', name: 'sor' },
  { id: 'sugárút', name: 'sugárút' },
  { id: 'egyéb', name: 'egyéb' }
];

const terms =
  // eslint-disable-next-line max-len
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Feugiat scelerisque varius morbi enim nunc faucibus. Vulputate enim nulla aliquet porttitor lacus luctus accumsan. Nibh nisl condimentum id venenatis. Dignissim sodales ut eu sem integer vitae justo eget. Mollis nunc sed id semper risus. Fusce id velit ut tortor pretium. Quam nulla porttitor massa id neque. Tellus integer feugiat scelerisque varius morbi enim nunc faucibus. Neque volutpat ac tincidunt vitae semper quis lectus nulla. Tristique sollicitudin nibh sit amet. Egestas fringilla phasellus faucibus scelerisque eleifend. Duis ultricies lacus sed turpis tincidunt id aliquet. Sit amet nulla facilisi morbi tempus iaculis urna id volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Feugiat scelerisque varius morbi enim nunc faucibus. Vulputate enim nulla aliquet porttitor lacus luctus accumsan. Nibh nisl condimentum id venenatis. Dignissim sodales ut eu sem integer vitae justo eget. Mollis nunc sed id semper risus. Fusce id velit ut tortor pretium. Quam nulla porttitor massa id neque. Tellus integer feugiat scelerisque varius morbi enim nunc faucibus. Neque volutpat ac tincidunt vitae semper quis lectus nulla. Tristique sollicitudin nibh sit amet. Egestas fringilla phasellus faucibus scelerisque eleifend. Duis ultricies lacus sed turpis tincidunt id aliquet. Sit amet nulla facilisi morbi tempus iaculis urna id volutpat.\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Feugiat scelerisque varius morbi enim nunc faucibus. Vulputate enim nulla aliquet porttitor lacus luctus accumsan. Nibh nisl condimentum id venenatis. Dignissim sodales ut eu sem integer vitae justo eget. Mollis nunc sed id semper risus. Fusce id velit ut tortor pretium. Quam nulla porttitor massa id neque. Tellus integer feugiat scelerisque varius morbi enim nunc faucibus. Neque volutpat ac tincidunt vitae semper quis lectus nulla. Tristique sollicitudin nibh sit amet. Egestas fringilla phasellus faucibus scelerisque eleifend. Duis ultricies lacus sed turpis tincidunt id aliquet. Sit amet nulla facilisi morbi tempus iaculis urna id volutpat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Feugiat scelerisque varius morbi enim nunc faucibus. Vulputate enim nulla aliquet porttitor lacus luctus accumsan. Nibh nisl condimentum id venenatis. Dignissim sodales ut eu sem integer vitae justo eget. Mollis nunc sed id semper risus. Fusce id velit ut tortor pretium. Quam nulla porttitor massa id neque. Tellus integer feugiat scelerisque varius morbi enim nunc faucibus. Neque volutpat ac tincidunt vitae semper quis lectus nulla. Tristique sollicitudin nibh sit amet. Egestas fringilla phasellus faucibus scelerisque eleifend. Duis ultricies lacus sed turpis tincidunt id aliquet. Sit amet nulla facilisi morbi tempus iaculis urna id volutpat.';

const fontStyle = {
  fontLink:
    'https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap',
  fontFamily: "'Poppins', sans-serif"
};

const constants = {
  addressDataInit,
  orderDataInit,
  modalDataInit,
  streetTypes,
  terms,
  days,
  fontStyle
};

export default constants;
